import { Flex, Space, Typography } from 'antd';
import styled from 'styled-components';

import { DeleteOutlined } from '@ant-design/icons';

export const TableContainer = styled(Flex)`
  .custom-table {
    .ant-table-title {
      background-color: ${({ theme }) => `${theme.colorFillQuaternary}`};
      border-bottom: ${({ theme }) => `solid 1px ${theme.colorBorderSecondary}`};
    }
    .custom-table-row {
      cursor: pointer;
    }
    .custom-table-row:hover td {
      background-color: ${({ theme }) => `${theme.controlItemBgActive}`};
      border-bottom: ${({ theme }) => `solid 1px ${theme.colorPrimary}`};
    }
    .custom-table-row:hover td:has(.gradient-overlay) .gradient-overlay {
      display: none;
    }
  }

  :has(> .ant-table-cell-row-hover) {
    .mobile-row-actions {
      display: flex;
    }
  }
  .ant-table {
    border-radius: 8px;
  }
  .ant-table-title {
    background-color: ${({ theme }) => `${theme.colorFillQuaternary}`};
  }

  thead {
    tr {
      th {
        padding-top: 12px !important;
        padding-left: 16px !important;
        padding-right: 16px !important;
      }
      th:first-child::before {
        display: none;
      }
    }
  }
  tr {
    td {
      padding-left: 16px !important;
      padding-right: 16px !important;
    }
  }
`;

export const StyledDeleteOutlined = styled(DeleteOutlined)`
  color: ${({ theme }) => theme.colorError};
`;

export const StyledSpace = styled(Space)`
  width: 100%;
  justify-content: flex-end;
`;

export const ResetPasswordWrapper = styled(Flex)`
  flex-direction: column;
  gap: 8px;
`;

export const ResetPasswordDescription = styled(Typography.Text)<{ $isDesktop: boolean }>`
  text-align: ${({ $isDesktop }) => ($isDesktop ? 'left' : 'center')};
`;
